var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7159 15.8691L0 29.2409V14.2505L17.7841 0.827293V14.1309L35.5 0.759155V15.7496L17.7159 29.1728V15.8691Z",
    fill: "#F8D24A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpBasic);
export default __webpack_public_path__ + "static/media/mp-basic.040392878f8f22ca45b83a076749fda9.svg";
export { ForwardRef as ReactComponent };